import { find } from '../helpers';

const element = find('[data-read-more]')

if (element) {
    import(/* webpackChunkName: "read-more" */'./index')
}

